export const backendConfigTest = {
  baseUrl: 'https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test',
  notifyUrl: 'https://5e0rg7uyfj.execute-api.ap-south-1.amazonaws.com/test/payments/notify'
};
